var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-header",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    md: "6"
                  }
                },
                [_vm._v(" Your Packages ")]
              ),
              _c(
                "v-col",
                {
                  staticClass: "text-right font-sm",
                  attrs: {
                    md: "6"
                  }
                },
                [
                  _c(
                    "gg-btn",
                    {
                      attrs: {
                        disabled: !_vm.featureListingAllowed,
                        color: "primary"
                      },
                      on: {
                        click: function click($event) {
                          return _vm.openAddEditModal()
                        }
                      }
                    },
                    [_vm._v(" Add Package ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      !_vm.featureListingAllowed
        ? _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c("v-col", [
                    _vm._v(
                      " You don't have enough permissions for this action "
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _c(
            "gg-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  items: _vm.packageList,
                  loading: _vm.loadingPackages,
                  headers: _vm.headers
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.actions",
                    fn: function fn(_ref) {
                      var item = _ref.item
                      return [
                        _c(
                          "gg-btn",
                          {
                            staticClass: "mr-2",
                            attrs: {
                              disabled: !!item.suspended,
                              to: {
                                path: "/hosting/shared/".concat(_vm.hostingid),
                                query: {
                                  user: item.user
                                }
                              }
                            }
                          },
                          [_vm._v(" Manage ")]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.manage",
                    fn: function fn(_ref2) {
                      var item = _ref2.item
                      return [
                        _c(
                          "v-menu",
                          {
                            attrs: {
                              "offset-y": ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function fn(_ref3) {
                                    var on = _ref3.on,
                                      attrs = _ref3.attrs
                                    return [
                                      _c(
                                        "gg-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                color: "primary"
                                              }
                                            },
                                            "gg-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(" Manage "),
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                right: ""
                                              }
                                            },
                                            [_vm._v("mdi-chevron-down")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _c(
                              "v-list",
                              [
                                _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function click($event) {
                                        return _vm.openAddEditModal(item.name)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-item-title",
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "pb-1",
                                            attrs: {
                                              small: ""
                                            }
                                          },
                                          [_vm._v("mdi-pencil")]
                                        ),
                                        _c("span", [_vm._v(" Edit ")])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-list-item",
                                  {
                                    on: {
                                      click: function click($event) {
                                        return _vm.deletePackage(item.name)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "v-list-item-title",
                                      [
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "pb-1",
                                            attrs: {
                                              small: ""
                                            }
                                          },
                                          [_vm._v("mdi-trash-can-outline")]
                                        ),
                                        _vm._v(" Delete ")
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
      _c("gg-modal", {
        attrs: {
          "is-active": _vm.isShowPackageModal
        },
        on: {
          close: function close($event) {
            _vm.isShowPackageModal = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function fn() {
              return [
                _vm._v(
                  " " + _vm._s(_vm.isAdding ? "Add" : "Edit") + " a Package "
                )
              ]
            },
            proxy: true
          },
          {
            key: "body",
            fn: function fn() {
              return [
                _c(
                  "v-row",
                  {
                    staticClass: "pt-3"
                  },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.packageName,
                                      expression: "rules.packageName"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    disabled: !_vm.isAdding,
                                    label: "Package Name",
                                    "data-vv-name": "packageName",
                                    "data-vv-as": "Package Name",
                                    "error-messages": _vm.errors.collect(
                                      "packageName"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.packageName,
                                    callback: function callback($$v) {
                                      _vm.$set(_vm.formData, "packageName", $$v)
                                    },
                                    expression: "formData.packageName"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "gg-card-header",
                          {
                            staticClass: "px-0",
                            attrs: {
                              divider: false
                            }
                          },
                          [_vm._v(" Resources ")]
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "mt-3"
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.quota,
                                      expression: "rules.quota"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    label: "Disk Space Quota (MB)",
                                    "data-vv-name": "quota",
                                    "data-vv-as": "Disk Space Quota",
                                    "error-messages": _vm.errors.collect(
                                      "quota"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.resources.quota,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.resources,
                                        "quota",
                                        $$v
                                      )
                                    },
                                    expression: "formData.resources.quota"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.bwlimit,
                                      expression: "rules.bwlimit"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    label: "Monthly Bandwidth Limit (MB)",
                                    "data-vv-name": "bwlimit",
                                    "data-vv-as": "Monthly Bandwidth Limit",
                                    "error-messages": _vm.errors.collect(
                                      "bwlimit"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.resources.bwlimit,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.resources,
                                        "bwlimit",
                                        $$v
                                      )
                                    },
                                    expression: "formData.resources.bwlimit"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.maxftp,
                                      expression: "rules.maxftp"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    label: "Max FTP Accounts",
                                    "data-vv-name": "maxftp",
                                    "data-vv-as": "Max FTP Accounts",
                                    "error-messages": _vm.errors.collect(
                                      "maxftp"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.resources.maxftp,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.resources,
                                        "maxftp",
                                        $$v
                                      )
                                    },
                                    expression: "formData.resources.maxftp"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.maxpop,
                                      expression: "rules.maxpop"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    label: "Max Email Accounts",
                                    "data-vv-name": "maxpop",
                                    "data-vv-as": "Max Email Accounts",
                                    "error-messages": _vm.errors.collect(
                                      "maxpop"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.resources.maxpop,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.resources,
                                        "maxpop",
                                        $$v
                                      )
                                    },
                                    expression: "formData.resources.maxpop"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.maxlst,
                                      expression: "rules.maxlst"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    label: "Max Mailing Lists",
                                    "data-vv-name": "maxlst",
                                    "data-vv-as": "Max Mailing Lists",
                                    "error-messages": _vm.errors.collect(
                                      "maxlst"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.resources.maxlst,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.resources,
                                        "maxlst",
                                        $$v
                                      )
                                    },
                                    expression: "formData.resources.maxlst"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.maxsql,
                                      expression: "rules.maxsql"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    label: "Max SQL Databases",
                                    "data-vv-name": "maxsql",
                                    "data-vv-as": "Max SQL Databases",
                                    "error-messages": _vm.errors.collect(
                                      "maxsql"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.resources.maxsql,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.resources,
                                        "maxsql",
                                        $$v
                                      )
                                    },
                                    expression: "formData.resources.maxsql"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.maxsub,
                                      expression: "rules.maxsub"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    label: "Max Sub Domains",
                                    "data-vv-name": "maxsub",
                                    "data-vv-as": "Max Sub Domains",
                                    "error-messages": _vm.errors.collect(
                                      "maxsub"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.resources.maxsub,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.resources,
                                        "maxsub",
                                        $$v
                                      )
                                    },
                                    expression: "formData.resources.maxsub"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.maxpark,
                                      expression: "rules.maxpark"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    label: "Max Parked Domains",
                                    "data-vv-name": "maxpark",
                                    "data-vv-as": "Max Parked Domains",
                                    "error-messages": _vm.errors.collect(
                                      "maxpark"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.resources.maxpark,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.resources,
                                        "maxpark",
                                        $$v
                                      )
                                    },
                                    expression: "formData.resources.maxpark"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.maxaddon,
                                      expression: "rules.maxaddon"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    label: "Max Addon Domains",
                                    "data-vv-name": "maxaddon",
                                    "data-vv-as": "Max Addon Domains",
                                    "error-messages": _vm.errors.collect(
                                      "maxaddon"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.resources.maxaddon,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.resources,
                                        "maxaddon",
                                        $$v
                                      )
                                    },
                                    expression: "formData.resources.maxaddon"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.maxpassengerapps,
                                      expression: "rules.maxpassengerapps"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    label: "Max Passenger Applications",
                                    "data-vv-name": "maxpassengerapps",
                                    "data-vv-as": "Max Passenger Applications",
                                    "error-messages": _vm.errors.collect(
                                      "maxpassengerapps"
                                    )
                                  },
                                  model: {
                                    value:
                                      _vm.formData.resources.maxpassengerapps,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.resources,
                                        "maxpassengerapps",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.resources.maxpassengerapps"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.max_email_per_hour,
                                      expression: "rules.max_email_per_hour"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    disabled: "disabled",
                                    label:
                                      "Maximum Hourly Email by Domain Relayed",
                                    "data-vv-name": "max_email_per_hour",
                                    "data-vv-as": "Maximum Hourly Email",
                                    "error-messages": _vm.errors.collect(
                                      "max_email_per_hour"
                                    )
                                  },
                                  model: {
                                    value:
                                      _vm.formData.resources.max_email_per_hour,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.resources,
                                        "max_email_per_hour",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.resources.max_email_per_hour"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value:
                                        _vm.rules.max_defer_fail_percentage,
                                      expression:
                                        "rules.max_defer_fail_percentage"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    disabled: "disabled",
                                    label:
                                      "Maximum percentage of failed or deferred messages a domain may send per hour",
                                    "data-vv-name": "max_defer_fail_percentage",
                                    "data-vv-as":
                                      "Maximum percentage of failed or deferred messages per hour",
                                    "error-messages": _vm.errors.collect(
                                      "max_defer_fail_percentage"
                                    )
                                  },
                                  model: {
                                    value:
                                      _vm.formData.resources
                                        .max_defer_fail_percentage,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.resources,
                                        "max_defer_fail_percentage",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.resources.max_defer_fail_percentage"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-text-field", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.max_emailacct_quota,
                                      expression: "rules.max_emailacct_quota"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    label: "Max Quota per Email Address (MB)",
                                    "data-vv-name": "max_emailacct_quota",
                                    "data-vv-as": "Max Quota per Email Address",
                                    "error-messages": _vm.errors.collect(
                                      "max_emailacct_quota"
                                    )
                                  },
                                  model: {
                                    value:
                                      _vm.formData.resources
                                        .max_emailacct_quota,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.resources,
                                        "max_emailacct_quota",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.resources.max_emailacct_quota"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "gg-card-header",
                          {
                            staticClass: "px-0",
                            attrs: {
                              divider: false
                            }
                          },
                          [_vm._v(" Settings ")]
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "mt-3"
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-select", {
                                  attrs: {
                                    outlined: "",
                                    label: "cPanel Theme",
                                    items: _vm.themes
                                  },
                                  model: {
                                    value: _vm.formData.settings.cpmod,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.settings,
                                        "cpmod",
                                        $$v
                                      )
                                    },
                                    expression: "formData.settings.cpmod"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-select", {
                                  attrs: {
                                    outlined: "",
                                    label: "Feature List",
                                    items: _vm.featureLists
                                  },
                                  model: {
                                    value: _vm.formData.settings.featurelist,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.settings,
                                        "featurelist",
                                        $$v
                                      )
                                    },
                                    expression: "formData.settings.featurelist"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c("gg-select", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: _vm.rules.language,
                                      expression: "rules.language"
                                    }
                                  ],
                                  attrs: {
                                    outlined: "",
                                    label: "Locale",
                                    items: [
                                      {
                                        label: "English",
                                        value: "en"
                                      }
                                    ],
                                    "item-value": "value",
                                    "item-text": "label",
                                    "data-vv-name": "language",
                                    "data-vv-as": "language",
                                    "error-messages": _vm.errors.collect(
                                      "language"
                                    )
                                  },
                                  model: {
                                    value: _vm.formData.settings.language,
                                    callback: function callback($$v) {
                                      _vm.$set(
                                        _vm.formData.settings,
                                        "language",
                                        $$v
                                      )
                                    },
                                    expression: "formData.settings.language"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "actions",
            fn: function fn() {
              return [
                _c(
                  "gg-btn",
                  {
                    attrs: {
                      primary: ""
                    },
                    on: {
                      click: _vm.save
                    }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.isAdding ? "Add" : "Save Changes") + " "
                    )
                  ]
                ),
                !_vm.isAdding
                  ? _c(
                      "gg-btn",
                      {
                        attrs: {
                          secondary: ""
                        },
                        on: {
                          click: function click($event) {
                            return _vm.reset(_vm.formData.packageName)
                          }
                        }
                      },
                      [_vm._v(" Reset ")]
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }